// gets all links, checks which ones have possible anchor
// on click remove defaults and smooth scroll if it supports the scrollBehavior feature
function initSmoothScrolling(offset){
  var links = document.querySelectorAll('a:not([role=tab])');
  var linksByClass = document.querySelectorAll('.has-scroll');
  var scrollElems = [];
  var offst = (offset) ? offset : 120;
  // Anchors that we want to ignore, set in initWatchOpenFormMenu()
  var exceptions = [
    //"#dont-trigger-smooth-scrolling",
  ]

  setScrollables(links);
  setScrollables(linksByClass);

  if(scrollElems.length > 0){
    for(var i = 0; i < scrollElems.length; i++){
      var elem = scrollElems[i];

      if(exceptions.indexOf(elem.getAttribute("href")) < 0){
        // We didn't found our href in the exceptions array

        if( !elem.classList.contains("accordion-title") ){
          // not an accordion, continue
          // Add listener

          elem.addEventListener('click',function(e) {
            e.preventDefault();
            // Get the element id to which you want to scroll and try to create object
            var potentialID = (e.target.href) ? e.target.href.split('#')[1] : e.currentTarget.href.split('#')[1];
            potentialID = (!potentialID && e.currentTarget) ? e.currentTarget.href.split('#')[1] : potentialID;
            var scrollEndElem = (potentialID ) ? document.getElementById(potentialID) : false;

            if(scrollEndElem){
              // an object exists
              var elmTop = getOffset(scrollEndElem).top;
              var left = 0;

              smoothScroll(left, elmTop, offst);
            } // if the element exists
          }); // listener
        }
      }
      else{
        // exceptions shouldn't scroll in firefox
        elem.addEventListener('click',function(e) {
          e.preventDefault();
        });
      }
    }// for
  }// if there are scrollElems
  function setScrollables(elmts){
    if( elmts.length > 0 ){
      for(var i = 0; i < elmts.length; i++){
        if(elmts[i].getAttribute("href")){
          // if it has an href attribute
          var href = (elmts[i].getAttribute("href")).trim();;
          if(href.substr(0, 1) == "#") scrollElems.push(elmts[i]);
        }
      }
    }
  }//setScrollable
}//initGoTo

// Reusable by other functions
function smoothScroll(left, top, offset){
  var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
  var options = {
      "behavior": "smooth",
      "left": left,
      "top": (top - offset)
  };

  if (isSmoothScrollSupported) {
      // Native smooth scrolling
      window.scrollTo(options);
  }
  else {
    // Old way scrolling without effects
    window.scrollTo(options.left, options.top);
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
DOMReady(function() {
  var tabletScreen = 991;
  if(getSize().w > tabletScreen){
    initSmoothScrolling(0);
  }
  else{
    initSmoothScrolling();
  }
});